import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { colors, shared } from '../styles/theme';

function About() {
  return (
    <section className={css(styles.page)}>
      <p className={css(styles.eyebrow)}>About YaBatho</p>
      <h1 className={css(styles.title)}>
        A live local delivery platform for people and businesses.
      </h1>
      <p className={css(styles.copy)}>
        YaBatho connects customers, restaurants, riders, and administrators in a
        single delivery ecosystem. It is designed to make local ordering easier,
        support restaurant operations, coordinate riders, and give the business
        team better oversight.
      </p>

      <div className={css(styles.grid)}>
        <article className={css(styles.card)}>
          <h2 className={css(styles.cardTitle)}>Local-first</h2>
          <p className={css(styles.cardText)}>
            YaBatho is built around local restaurants, local customers, and
            practical delivery operations.
          </p>
        </article>
        <article className={css(styles.card)}>
          <h2 className={css(styles.cardTitle)}>Operationally connected</h2>
          <p className={css(styles.cardText)}>
            The platform connects ordering, preparation, delivery, finance, and
            admin workflows.
          </p>
        </article>
        <article className={css(styles.card)}>
          <h2 className={css(styles.cardTitle)}>Ready to grow</h2>
          <p className={css(styles.cardText)}>
            The public website, customer access, and partner onboarding flows
            are now structured for live use.
          </p>
        </article>
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  page: {
    ...shared.navPage,
  },
  eyebrow: shared.eyebrow,
  title: {
    margin: '0 0 18px',
    color: colors.ink,
    fontSize: '3.2rem',
    fontWeight: '900',
    lineHeight: 1.05,
    maxWidth: '940px',
    '@media (max-width: 520px)': {
      fontSize: '2rem',
      lineHeight: 1.08,
    },
  },
  copy: {
    margin: '0 0 34px',
    color: colors.muted,
    fontSize: '1.06rem',
    lineHeight: 1.8,
    maxWidth: '860px',
    '@media (max-width: 520px)': {
      fontSize: '0.98rem',
      lineHeight: 1.65,
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '16px',

    '@media (max-width: 860px)': {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    padding: '24px',
    boxShadow: '0 10px 28px rgba(30, 30, 30, 0.05)',
  },
  cardTitle: {
    margin: '0 0 10px',
    color: colors.ink,
    fontSize: '1.18rem',
  },
  cardText: {
    margin: 0,
    color: colors.muted,
    lineHeight: 1.65,
  },
});

export default About;
